import { Component, OnInit } from '@angular/core';

import { Widget, Dashboard } from 'src/api/models'
import { IWidgetEditor, WidgetType, TimeSeriesDetail } from "src/app/models/dashboard";

@Component({
  selector: 'app-iframe-widget-editor',
  templateUrl: './iframe-widget-editor.component.html',
  styleUrls: ['./iframe-widget-editor.component.css']
})
export class IFrameWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: Widget;
  public dashboard: Dashboard;
  public w: any;
  public active: TimeSeriesDetail;

  constructor() { }

  ngOnInit() {
    this.w = <any>this.widget;
    //this.active = this.w.timeSeries;
  }

  public selectedPrimary(value: any): void {
    this.w.timeSeries.uri = value;
  }
}
